import React from 'react';
import Cookie from 'js-cookie';

import { getUserFromCookie } from 'util/auth';
import styles from './SiteHeaderNewsletter.styles';

// we're setting a cookie for authenticated users that contains their email
// address so we can avoid passing their email address in the query string. for
// right now it's just a small deterrent for people abusing the fastly redirect.
//
// the cookie we set here is expired/cleared via HTTP headers in the redirect
// response. (we don't want to keep the user's email in a cookie any longer than
// absolutely necessary.)
//
// NOTE: the authenticated user redirect on fastly only functions correctly in
// production on our public domains due to domain-specific cookies. see fastly
// VCL rules for more info on how this works.
//
const REDIRECT_URL = '/_r/newsletters';
const SAILTHRU_EMAIL = 'tmp_st_eml';

function handleClick() {
  const userData = getUserFromCookie();
  if (userData) {
    Cookie.set(SAILTHRU_EMAIL, userData.email);
  }
}

function SiteHeaderNewsletter() {
  return (
    <div className="SiteHeaderNewsletter">
      <a
        className="SiteHeaderNewsletter__link"
        data-gtm-trigger="navigation-email-newsletter-nav-link-click"
        data-gtm-newsletter-link-text="Newsletters"
        // using normal anchor + href here because this is a redirect, not a
        // on-site page that would benefit from next's Link component.
        href={REDIRECT_URL}
        onClick={handleClick}
      >
        Newsletters
      </a>
      <style jsx>{styles}</style>
    </div>
  );
}

export default SiteHeaderNewsletter;
